import {dispatchAcknowledgedEvent} from '../../core/resourceEvents';
import {openGuestPlansSection} from '../ioPass/adapter';
import {
	GUEST_PLAN_FILTER_EVENT,
	GUEST_PLAN_FOCUS_EVENT,
} from './events';

/**
 * Open the Guest Access Plans list.
 *
 * Reuses the IO-Pass adapter, the same way Captive Portals does: the
 * accordion is on the Configuration tab, and getting there is the same two
 * steps whether the request was for the list or for a row in it.
 *
 * @return {Promise<void>} completion
 */
export function openGuestPlanSection() {
	return openGuestPlansSection();
}

/**
 * Narrow the Guest Access Plans table to a search term.
 * @param {object} command filter command
 * @return {Promise<object>} acknowledgement
 */
export function applyGuestPlanFilter(command) {
	return dispatchAcknowledgedEvent(GUEST_PLAN_FILTER_EVENT, {
		query: String(command.params?.query || '').trim(),
		resource: 'guest_plan',
	});
}

/**
 * Bring one guest access plan's row into view.
 * @param {object} command focus command
 * @return {Promise<object>} acknowledgement
 */
export function focusGuestPlan(command) {
	return dispatchAcknowledgedEvent(GUEST_PLAN_FOCUS_EVENT, {
		entityId: String(command.params?.entity_id || ''),
		resource: 'guest_plan',
	});
}
